/**
 * interaction/facades/keyword.facade.instance.js
 *
 * Production wiring — creates the keyword facade with real dependencies.
 */

import { createKeywordFacade } from './keyword.facade.js';
import {
  preCheckKeywords,
  marketDataKeywords,
  translateSearchTerms,
  keywordCoverageAnalyze,
  listingOptimizerDiagnose,
} from '../../api/keyword-api.js';

export const keywordFacade = createKeywordFacade({
  preCheckKeywords,
  marketDataKeywords,
  translateSearchTerms,
  keywordCoverageAnalyze,
  listingOptimizerDiagnose,
});
